/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {convertFetchResponseToReactQueryResponse} from '../tools';
import {ApiResponse} from '../types';
import {
    useMutation,
    UseMutationOptions,
    UseMutationResult,
    useQuery,
    useQueryClient,
    UseQueryOptions,
    UseQueryResult,
    QueryClient,
    useInfiniteQuery,
    UseInfiniteQueryOptions,
    UseInfiniteQueryResult,
} from 'react-query';
import {
    AdminAllPalletOrdersResponse,
    AdminAllPalletOrdersResponseFromJSON,
    AdminAllPalletOrdersResponseToJSON,
} from '../models';

import {AdminGetAllPalletsApi} from './AdminGetAllPalletsApi';

type AdminGetAllPalletsQueryOptions = UseQueryOptions<
    AdminAllPalletOrdersResponse,
    Array<Error>,
    AdminAllPalletOrdersResponse,
    ['adminGetAllPallets']
>;

let useAdminGetAllPalletsQueryGlobalOptions:
    | ((
          queryClient: QueryClient,
          options?: AdminGetAllPalletsQueryOptions
      ) => AdminGetAllPalletsQueryOptions | undefined)
    | undefined = undefined;

export function registerUseAdminGetAllPalletsQueryGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: AdminGetAllPalletsQueryOptions
    ) => AdminGetAllPalletsQueryOptions | undefined
) {
    useAdminGetAllPalletsQueryGlobalOptions = callback;
}

export function getAdminGetAllPalletsQueryKey(): ['adminGetAllPallets'] {
    return ['adminGetAllPallets'];
}

export function useAdminGetAllPalletsQuery(
    options?: AdminGetAllPalletsQueryOptions
): UseQueryResult<AdminAllPalletOrdersResponse, Array<runtime.ApiError>> {
    const queryClient = useQueryClient();
    return useQuery(
        getAdminGetAllPalletsQueryKey(),
        async ({signal}) =>
            convertFetchResponseToReactQueryResponse(await new AdminGetAllPalletsApi().adminGetAllPallets({signal})),
        {
            ...options,
            ...useAdminGetAllPalletsQueryGlobalOptions?.(queryClient, options),
        }
    );
}

type AdminGetAllPalletsMutationOptions = UseMutationOptions<AdminAllPalletOrdersResponse, Array<Error>>;

let useAdminGetAllPalletsMutationGlobalOptions:
    | ((
          queryClient: QueryClient,
          options?: AdminGetAllPalletsMutationOptions
      ) => AdminGetAllPalletsMutationOptions | undefined)
    | undefined = undefined;

export function registerUseAdminGetAllPalletsMutationGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: AdminGetAllPalletsMutationOptions
    ) => AdminGetAllPalletsMutationOptions | undefined
) {
    useAdminGetAllPalletsMutationGlobalOptions = callback;
}

export function useAdminGetAllPalletsMutation(
    options?: AdminGetAllPalletsMutationOptions
): UseMutationResult<AdminAllPalletOrdersResponse, Array<runtime.ApiError>, void> {
    const queryClient = useQueryClient();
    return useMutation(
        async (params) =>
            convertFetchResponseToReactQueryResponse(await new AdminGetAllPalletsApi().adminGetAllPallets()),
        {
            ...options,
            ...useAdminGetAllPalletsMutationGlobalOptions?.(queryClient, options),
        }
    );
}

export function getAdminGetAllPalletsInfiniteQueryKey(): ['adminGetAllPallets-infinite'] {
    return ['adminGetAllPallets-infinite'];
}

export function useAdminGetAllPalletsInfiniteQuery(
    options?: Omit<
        UseInfiniteQueryOptions<
            AdminAllPalletOrdersResponse,
            Array<runtime.ApiError>,
            AdminAllPalletOrdersResponse,
            AdminAllPalletOrdersResponse,
            ['adminGetAllPallets-infinite']
        >,
        'queryKey' | 'queryFn' | 'getNextPageParam'
    >
): UseInfiniteQueryResult<AdminAllPalletOrdersResponse, Array<runtime.ApiError>> {
    return useInfiniteQuery(
        getAdminGetAllPalletsInfiniteQueryKey(),
        async (context) =>
            convertFetchResponseToReactQueryResponse(await new AdminGetAllPalletsApi().adminGetAllPallets()),
        {
            ...options,
            getNextPageParam(lastPage, allPages) {
                const totalPages = (lastPage as any)?.totalPages || 0;
                if (allPages.length >= totalPages) {
                    return undefined;
                }
                return allPages.length + 1;
            },
        }
    );
}
